export const translations = {
  en: {
    nav: {
      day: "The Day",
      menu: "Menu",
      events: "Events",
      gallery: "Gallery",
      contact: "Contact",
      reserve: "Book Now",
      fullMenu: "Full Menu",
    },
    hero: {
      est: "Athens Riviera · Est. 2026",
      sub: "Beachfront Restaurant & Beach Club · Varkiza Resort",
      tagline: "Sand in our feet. Sun in our soul. Life in balance.",
      tagline2: "Sand Life. Live the moment.",
      msgA: "Sand in our feet.",
      msgB: "Sun in our soul.",
      msgC: "Life in balance.",
      hours: "09:00 — 02:00 · one sand · three tempos",
      cta: "Book your table",
      ctaMenu: "See the menu",
      scroll: "scroll",
    },
    marquee: ["sand · sea · soul", "varkiza, athens riviera", "sand life", "live the moment", "est. 2026", "09:00 — 02:00", "sea to table", "sunset sets"],
    welcome: {
      label: "Varkiza · Athens Riviera",
      title: "Welcome to the world of",
      body: "Born where the sand of Varkiza meets the life that happens on it, VAMMOS captures one continuous Mediterranean day — coffee at nine, fish at two, golden hour at eight, a full dancefloor at midnight. The guest never has to leave. The place changes around them.",
      body2: "Every detail is orchestrated with effortless precision — SUAR wood, macramé, bamboo, rope and linen; light, sound and texture following the sun from first swim to last beat. Premium without pretension. Barefoot at noon, dressed at night.",
    },
    gastro: {
      label: "Gastronomy",
      body: "Gastronomy lies at the heart of VAMMOS. The boats of the Saronic decide the menu; the charcoal decides the method. Whole fish on ice, chosen at the table, grilled over olive wood — fig wood after dark. Nothing imported that Greece can provide.",
      cta: "Discover the menu",
    },
    arc: {
      label: "The Sand Life Arc",
      titleA: "One sand.",
      titleB: "Five hours of light, five of fire.",
      intro:
        "Energy rises with the dark, never before it. Each phase hands over to the next without a seam. A guest who arrives at 10:00 and leaves at 01:00 has been to one place.",
      curve: "Energy curve · 09:00 → 02:00",
      phases: [
        {
          time: "09:00",
          name: "Beach · Silence",
          title: "Sand & Coffee",
          desc: "Sunbeds, freddo, sea. No music — the Aegean is the soundtrack. Light breakfast and juices from the beach bar. The day starts barefoot.",
          sound: "Sound: none · 0dB programme",
        },
        {
          time: "13:00",
          name: "Table · The Fish",
          title: "The Long Lunch",
          desc: "The kitchen at full strength. Raw bar, the day's catch on charcoal, cold Assyrtiko. Low organic playlists begin after 14:00 — felt, not heard.",
          sound: "Sound: ambient · 60–68dB",
        },
        {
          time: "17:30",
          name: "The Turn · Golden Hour",
          title: "Sunset Sets",
          desc: "Resident DJ on the deck. Melodic, organic house — the tempo of the light going down. Cocktails peak. The beach crowd and the dinner crowd overlap and stay.",
          sound: "Sound: live DJ · 70–78dB",
        },
        {
          time: "21:00",
          name: "Fire · Dinner & Build",
          title: "Dinner on the Edge",
          desc: "Fig-wood grill, candlelight, the music a degree deeper every half hour. Dinner tables become standing tables. Nobody announces anything. It just builds.",
          sound: "Sound: deep · 78–85dB",
        },
        {
          time: "23:00",
          name: "Sand Life · Peak",
          title: "The Party",
          desc: "Full sound. Dancefloor on the sand. Guest DJs, percussion, the sea black behind the lights. This is what the whole day was building toward — and tomorrow at 09:00 it will be silent again.",
          sound: "Sound: full · to 02:00 · licensed",
        },
      ],
    },
    menuHl: {
      label: "The Kitchen",
      titleA: "The fish is the spine.",
      titleB: "Everything else is rhythm.",
      intro:
        "Greek-Mediterranean, fish-first. The boats of the Saronic decide the menu; the charcoal decides the method. Whole fish on ice, chosen at the table.",
      cta: "The full menu",
      quote: "“The fish came in this morning. The DJ comes in at sunset. Both from around here.”",
    },
    events: {
      label: "The Party Calendar",
      titleA: "The day earns",
      titleB: "the night.",
      intro: "Signature formats. The music follows the sun — then replaces it.",
      list: [
        {
          name: "FULL MOON",
          when: "Every full moon · June — Sept",
          desc: "The biggest night of each month. Extended hours, headline guest, the moon doing the lighting design.",
        },
        {
          name: "ΑΜΜΟΣ Sundays",
          when: "Every Sunday · from 17:00",
          desc: "The weekly institution. Sunset-to-late, residents only, locals first. The Sunday that ends the weekend properly.",
        },
        {
          name: "FIRST LIGHT",
          when: "Season opening · June",
          desc: "Opening weekend. The first fire of the grill, the first set of the residency. Invitation-led, then open.",
        },
        {
          name: "LAST SAND",
          when: "Season closing · October",
          desc: "The closing ritual. Day-to-night marathon, every resident plays, the season ends on the floor it started on.",
        },
      ],
      sound: [
        { time: "09:00 — 17:00", name: "Sea Level", desc: "Morning: nothing — the Aegean is the playlist. From 14:00, low organic textures. Conversations always win." },
        { time: "17:30 — 22:00", name: "Sunset Sets", desc: "Resident DJs daily. Melodic and organic house pacing the light down. The signature VAMMOS moment." },
        { time: "22:00 — 02:00", name: "Sand Life Nights", desc: "The floor opens. Guest DJs, live percussion, afro and melodic house into peak-time. On sand, barefoot if you want." },
      ],
    },
    gallery: {
      label: "The Place",
      titleA: "Άμμος underfoot.",
      titleB: "Everything else follows.",
    },
    reserve: {
      label: "Reservations",
      titleA: "Arrive for lunch.",
      titleB: "Decide at sunset.",
      titleC: "Leave when it ends.",
      callUs: "Call for a table",
      phone: "+30 6936 61 44 42",
      note: "Lunch barefoot. Dinner dressed. Dance however you like.",
      sunset: "Sunset set starts at 19:30. The sun is punctual. Be too.",
      hoursLabel: "Hours",
      hours: "Daily 09:00 — 02:00 · June to October",
      whereLabel: "Where",
      where: "Poseidonos Avenue, Varkiza Beach",
      where2: "Athens Riviera · 166 72",
      followLabel: "Follow",
    },
    footer: {
      quoteA: "Sand in our feet. Sun in our soul.",
      quoteB: "Life in balance.",
      season: "Varkiza Resort · Athens Riviera · 09:00 — 02:00 · Season 2026",
      rights: "VAMMOS sand life · All rights reserved",
      menu: "Menu",
      day: "The Day",
      events: "Events",
      contact: "Contact",
    },
    menuPage: {
      label: "Menu · Varkiza · Athens Riviera · 2026",
      titleA: "The boats decide the fish.",
      titleB: "The charcoal decides the method.",
      intro: "Prices include VAT and all charges. * = Frozen product.",
      perPerson: "/ person",
      perKg: "/ kg",
      back: "Back",
      reserve: "Reserve a table",
    },
  },

  gr: {
    nav: {
      day: "Η Μέρα",
      menu: "Μενού",
      events: "Events",
      gallery: "Gallery",
      contact: "Επικοινωνία",
      reserve: "Κράτηση",
      fullMenu: "Πλήρες Μενού",
    },
    hero: {
      est: "Αθηναϊκή Ριβιέρα · Est. 2026",
      sub: "Beachfront Restaurant & Beach Club · Varkiza Resort",
      tagline: "Άμμος στα πόδια. Ήλιος στην ψυχή. Ζωή σε ισορροπία.",
      tagline2: "Sand Life. Ζήσε τη στιγμή.",
      msgA: "Άμμος στα πόδια.",
      msgB: "Ήλιος στην ψυχή.",
      msgC: "Ζωή σε ισορροπία.",
      hours: "09:00 — 02:00 · μία άμμος · τρία tempo",
      cta: "Κλείσε τραπέζι",
      ctaMenu: "Δες το μενού",
      scroll: "κύλισε",
    },
    marquee: ["άμμος · θάλασσα · ψυχή", "βάρκιζα, αθηναϊκή ριβιέρα", "sand life", "ζήσε τη στιγμή", "est. 2026", "09:00 — 02:00", "από τη θάλασσα στο τραπέζι", "sunset sets"],
    welcome: {
      label: "Βάρκιζα · Αθηναϊκή Ριβιέρα",
      title: "Καλώς ήρθες στον κόσμο του",
      body: "Γεννημένο εκεί όπου η άμμος της Βάρκιζας συναντά τη ζωή που συμβαίνει πάνω της, το VAMMOS αιχμαλωτίζει μία συνεχόμενη μεσογειακή μέρα — καφές στις εννιά, ψάρι στις δύο, golden hour στις οκτώ, γεμάτο dancefloor τα μεσάνυχτα. Ο επισκέπτης δεν χρειάζεται να φύγει ποτέ. Ο χώρος αλλάζει γύρω του.",
      body2: "Κάθε λεπτομέρεια ενορχηστρωμένη με αβίαστη ακρίβεια — ξύλο SUAR, μακραμέ, μπαμπού, σχοινί και λινό· φως, ήχος και υφές που ακολουθούν τον ήλιο από την πρώτη βουτιά ως το τελευταίο beat. Premium χωρίς επιτήδευση. Ξυπόλητοι το μεσημέρι, ντυμένοι το βράδυ.",
    },
    gastro: {
      label: "Γαστρονομία",
      body: "Η γαστρονομία είναι η καρδιά του VAMMOS. Οι βάρκες του Σαρωνικού αποφασίζουν το μενού· τα κάρβουνα τη μέθοδο. Ολόκληρα ψάρια στον πάγο, επιλέγονται στο τραπέζι, ψήνονται σε ξύλο ελιάς — ξύλο συκιάς μετά το σκοτάδι. Τίποτα εισαγόμενο απ' όσα δίνει η Ελλάδα.",
      cta: "Ανακάλυψε το μενού",
    },
    arc: {
      label: "Η Καμπύλη του Sand Life",
      titleA: "Μία άμμος.",
      titleB: "Πέντε ώρες φως, πέντε φωτιά.",
      intro:
        "Η ενέργεια ανεβαίνει με το σκοτάδι, ποτέ πριν από αυτό. Κάθε φάση παραδίδει στην επόμενη χωρίς ραφή. Όποιος έρθει στις 10:00 και φύγει στη 01:00, έχει πάει σε ένα μέρος.",
      curve: "Καμπύλη ενέργειας · 09:00 → 02:00",
      phases: [
        {
          time: "09:00",
          name: "Παραλία · Σιωπή",
          title: "Άμμος & Καφές",
          desc: "Ξαπλώστρες, freddo, θάλασσα. Καθόλου μουσική — το Αιγαίο είναι το soundtrack. Ελαφρύ πρωινό και χυμοί από το beach bar. Η μέρα ξεκινά ξυπόλητη.",
          sound: "Ήχος: κανένας · πρόγραμμα 0dB",
        },
        {
          time: "13:00",
          name: "Τραπέζι · Το Ψάρι",
          title: "Το Μεγάλο Μεσημέρι",
          desc: "Η κουζίνα σε πλήρη δύναμη. Raw bar, η ψαριά της ημέρας στα κάρβουνα, παγωμένο Ασύρτικο. Χαμηλά organic playlists μετά τις 14:00 — τα νιώθεις, δεν τα ακούς.",
          sound: "Ήχος: ambient · 60–68dB",
        },
        {
          time: "17:30",
          name: "Η Στροφή · Golden Hour",
          title: "Sunset Sets",
          desc: "Resident DJ στο deck. Melodic, organic house — στο tempo του φωτός που πέφτει. Τα cocktails στην κορύφωση. Η παρέα της παραλίας και του δείπνου μπλέκουν και μένουν.",
          sound: "Ήχος: live DJ · 70–78dB",
        },
        {
          time: "21:00",
          name: "Φωτιά · Δείπνο & Build",
          title: "Δείπνο στην Άκρη",
          desc: "Ψησταριά με ξύλο συκιάς, κεριά, η μουσική έναν τόνο βαθύτερη κάθε μισή ώρα. Τα τραπέζια γίνονται όρθια. Κανείς δεν ανακοινώνει τίποτα. Απλώς χτίζεται.",
          sound: "Ήχος: deep · 78–85dB",
        },
        {
          time: "23:00",
          name: "Sand Life · Κορύφωση",
          title: "Το Πάρτι",
          desc: "Πλήρης ήχος. Dancefloor πάνω στην άμμο. Guest DJs, κρουστά, η θάλασσα μαύρη πίσω από τα φώτα. Γι' αυτό έχτιζε όλη η μέρα — και αύριο στις 09:00 θα είναι ξανά σιωπή.",
          sound: "Ήχος: full · έως 02:00 · αδειοδοτημένο",
        },
      ],
    },
    menuHl: {
      label: "Η Κουζίνα",
      titleA: "Το ψάρι είναι η ραχοκοκαλιά.",
      titleB: "Όλα τα άλλα είναι ρυθμός.",
      intro:
        "Ελληνική-μεσογειακή, με το ψάρι πρώτο. Οι βάρκες του Σαρωνικού αποφασίζουν το μενού· τα κάρβουνα τη μέθοδο. Ολόκληρα ψάρια στον πάγο, επιλέγονται στο τραπέζι.",
      cta: "Το πλήρες μενού",
      quote: "«Το ψάρι ήρθε σήμερα το πρωί. Ο DJ έρχεται στο ηλιοβασίλεμα. Κι οι δύο από εδώ γύρω.»",
    },
    events: {
      label: "Το Ημερολόγιο της Νύχτας",
      titleA: "Η μέρα κερδίζει",
      titleB: "τη νύχτα.",
      intro: "Signature formats. Η μουσική ακολουθεί τον ήλιο — και μετά τον αντικαθιστά.",
      list: [
        {
          name: "FULL MOON",
          when: "Κάθε πανσέληνο · Ιούνιος — Σεπτ.",
          desc: "Η μεγαλύτερη νύχτα κάθε μήνα. Παρατεταμένο ωράριο, headline guest, και το φεγγάρι αναλαμβάνει τον φωτισμό.",
        },
        {
          name: "ΑΜΜΟΣ Sundays",
          when: "Κάθε Κυριακή · από 17:00",
          desc: "Ο εβδομαδιαίος θεσμός. Από το ηλιοβασίλεμα μέχρι αργά, μόνο residents, πρώτα οι ντόπιοι. Η Κυριακή που κλείνει σωστά το σαββατοκύριακο.",
        },
        {
          name: "FIRST LIGHT",
          when: "Άνοιγμα σεζόν · Ιούνιος",
          desc: "Το σαββατοκύριακο του ανοίγματος. Η πρώτη φωτιά στη σχάρα, το πρώτο set του residency. Με πρόσκληση, μετά ανοιχτά.",
        },
        {
          name: "LAST SAND",
          when: "Κλείσιμο σεζόν · Οκτώβριος",
          desc: "Η τελετή του κλεισίματος. Μαραθώνιος από μέρα σε νύχτα, παίζουν όλοι οι residents, η σεζόν τελειώνει στο ίδιο dancefloor που ξεκίνησε.",
        },
      ],
      sound: [
        { time: "09:00 — 17:00", name: "Sea Level", desc: "Πρωί: τίποτα — το Αιγαίο είναι η playlist. Από τις 14:00, χαμηλές organic υφές. Οι συζητήσεις κερδίζουν πάντα." },
        { time: "17:30 — 22:00", name: "Sunset Sets", desc: "Resident DJs καθημερινά. Melodic και organic house στο ρυθμό του φωτός. Η υπογραφή του VAMMOS." },
        { time: "22:00 — 02:00", name: "Sand Life Nights", desc: "Ανοίγει το dancefloor. Guest DJs, ζωντανά κρουστά, afro και melodic house μέχρι την κορύφωση. Πάνω στην άμμο, ξυπόλητοι αν θες." },
      ],
    },
    gallery: {
      label: "Ο Χώρος",
      titleA: "Άμμος κάτω από τα πόδια.",
      titleB: "Όλα τα άλλα ακολουθούν.",
    },
    reserve: {
      label: "Κρατήσεις",
      titleA: "Έλα για μεσημέρι.",
      titleB: "Αποφάσισε στο ηλιοβασίλεμα.",
      titleC: "Φύγε όταν τελειώσει.",
      callUs: "Τηλέφωνο κρατήσεων",
      phone: "+30 6936 61 44 42",
      note: "Μεσημέρι ξυπόλητοι. Βράδυ ντυμένοι. Χορέψτε όπως θέλετε.",
      sunset: "Το sunset set ξεκινά στις 19:30. Ο ήλιος είναι συνεπής. Να είσαι κι εσύ.",
      hoursLabel: "Ωράριο",
      hours: "Καθημερινά 09:00 — 02:00 · Ιούνιος έως Οκτώβριος",
      whereLabel: "Πού",
      where: "Λεωφόρος Ποσειδώνος, Παραλία Βάρκιζας",
      where2: "Αθηναϊκή Ριβιέρα · 166 72",
      followLabel: "Follow",
    },
    footer: {
      quoteA: "Άμμος στα πόδια. Ήλιος στην ψυχή.",
      quoteB: "Ζωή σε ισορροπία.",
      season: "Varkiza Resort · Αθηναϊκή Ριβιέρα · 09:00 — 02:00 · Σεζόν 2026",
      rights: "VAMMOS sand life · Με επιφύλαξη παντός δικαιώματος",
      menu: "Μενού",
      day: "Η Μέρα",
      events: "Events",
      contact: "Επικοινωνία",
    },
    menuPage: {
      label: "Μενού · Βάρκιζα · Αθηναϊκή Ριβιέρα · 2026",
      titleA: "Οι βάρκες αποφασίζουν το ψάρι.",
      titleB: "Τα κάρβουνα τη μέθοδο.",
      intro: "Στις τιμές περιλαμβάνονται Φ.Π.Α. και λοιπές επιβαρύνσεις. * = Κατεψυγμένο προϊόν.",
      perPerson: "/ άτομο",
      perKg: "/ κιλό",
      back: "Πίσω",
      reserve: "Κράτηση τραπεζιού",
    },
  },
};
